// THE RELOAD CHIP, top left (Matt, 2026-10-19: "add a refresh button to the top left, just like the dev mode on WHYTE
// KNUCKLE"). Ported from the gaming repo's src/whyteknuckle/85_debug.js #rld, which has been on the live arcade since
// v1.02 so a phone holding a stale copy can fetch the new one.
//  - A fresh ?v= on the URL is what actually refetches (location.reload(true) has been ignored for years); every other
//    query parameter is kept (?guest=1, ?go=1), but the #sso= one-time code is dropped: it is spent, and a reload that
//    offered it again would be refused (4001). The session token in localStorage signs you back in.
//  - It shows the BUILD (the commit the deploy built, esbuild --define __BUILD__), so a reload can be checked: if the six
//    characters are the same after the tap, the new deploy has not landed.
//  - It acts on a click, never on a touchstart (WK R3-002: a brushing thumb threw a run away). In the world a reload
//    drops you off the street for a moment, so there the first tap only asks - TAP AGAIN - and the second, inside three
//    seconds, reloads. On the title it reloads at once.
//  - #topbar steps right by the chip's width (style.css --rld-w), and hudfit.ts keeps world labels off it.
declare const __BUILD__: string;

export function reloadChip() {
  if (document.getElementById('rld')) return;
  const r = document.createElement('button');
  r.id = 'rld'; r.type = 'button'; r.setAttribute('aria-label', 'Reload the game');
  let build = '';
  try { build = typeof __BUILD__ === 'string' ? __BUILD__ : ''; } catch { build = ''; }
  // the arrow in a font that has one (the pixel font does not), the words in the HUD's own
  const say = (t: string) => { const a = document.createElement('b'); a.setAttribute('aria-hidden', 'true'); a.textContent = '↻'; r.replaceChildren(a); if (t) r.append(t); fit(); };
  // hud2 (cycle 001): the arrow only on screen; the build is in the title, the label and the first tap's TAP AGAIN
  const hud2 = document.body.classList.contains('hud2');
  if (hud2) { r.title = `Reload the game (build ${build || 'dev'})`; r.setAttribute('aria-label', r.title); }
  const stamp = () => say(hud2 ? '' : build);
  const fit = () => { const w = r.offsetWidth; if (w) document.documentElement.style.setProperty('--rld-w', `${w + 6}px`); };
  const inWorld = () => { const h = document.getElementById('hud'); return !!h && !h.hidden; };
  let armed = 0;
  r.addEventListener('click', e => {
    e.preventDefault(); e.stopPropagation();
    if (inWorld() && performance.now() - armed > 3000) {
      armed = performance.now();
      say(hud2 ? `TAP AGAIN ${build}` : 'TAP AGAIN');
      setTimeout(() => { if (performance.now() - armed >= 3000) { armed = 0; stamp(); } }, 3050);
      return;
    }
    say('...');
    try {
      const u = new URL(location.href);
      u.searchParams.set('v', Date.now().toString(36));
      u.hash = '';
      location.href = u.toString();
    } catch {
      location.href = location.pathname + '?v=' + Date.now().toString(36);
    }
  });
  // the touch is the chip's own: the stick, the canvas and the menus must not read it
  for (const ev of ['touchstart', 'pointerdown', 'mousedown'] as const) r.addEventListener(ev, e => e.stopPropagation(), { passive: true });
  document.body.appendChild(r);
  stamp();
  addEventListener('resize', fit);
  document.fonts?.ready.then(fit).catch(() => {});
}
